import { render, staticRenderFns } from "./JuegosProlipa.vue?vue&type=template&id=222f245e"
import script from "./JuegosProlipa.vue?vue&type=script&lang=js"
export * from "./JuegosProlipa.vue?vue&type=script&lang=js"
import style0 from "./JuegosProlipa.vue?vue&type=style&index=0&id=222f245e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports